import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import FormLogo from '../OnlineForm/components/FormLogo';
import WhatsAppShare from './WhatsappShare';
import '../styles/FormThanks.css';
import GoogleAd from './GoogleAd';

const FormThanks = ({language, onClose}) => {
    const { t } = useTranslation();
    const site = 'https://vipe.uy/';

    useEffect(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }, []);

      const handleRedirect = () => {
        window.location.href = site;
      };
    return (
        <>
            <div className='preview-thanks'>
                <FormLogo />
                <div className='give-us-opinion'>
                    <p>{t('card.giveUsOpinion')}</p>
                    <a className='opinionLink' href={t('card.opinionLink')} target='_blank' rel='noopener noreferrer'>
                        {t('card.survey')}
                    </a>
                </div>
                <div className='official-site'>
                    <p className='thanks-text'>{t('card.thanks')}<a className='mainSiteUrl' href={site} target='_blank' rel='noopener noreferrer'>
                        {t('card.mainSite')}
                    </a></p>
                    
                </div>
                <div className='help-us'>
                    <p>{t('card.helpUs')}</p>
                </div>
                <div className='row-two'>
                    <WhatsAppShare language={language}/>
                </div>
                <div className='next-back-div-prev-thanks'>
                    <button className='square-button-back-thanks' onClick={onClose}>
                        <span className="button-text">{t('form.previous')}</span>
                    </button>
                    <button className='square-button-back-thanks' onClick={handleRedirect}>
                        {t('form.finish')}
                    </button>
                </div>
                {/* <div className='google-ad-div'>
                    <GoogleAd 
                    client="ca-pub-3940256099942544"
                    slot="7259870550" />
                </div> */}
            </div>
        </>
)
}

export default FormThanks